import { call, put, takeLatest, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import { getClubShipmentVirtualCart } from 'redux/clubMemberShipments/api';
import { getClubPackage } from 'redux/clubPackages/api';
import { LIST_CLUB_PACKAGES_SUCCESS } from 'redux/clubPackages/constants';
import { getSubscriptionClubShipmentVirtualCart } from 'redux/clubSubscriptionShipments/api';

import { getCustomerDashboard } from './api';
import {
  CUSTOMER_DASHBOARD_OBJECT_REQUESTING,
  GET_CUSTOMER_DASHBOARD_SUCCESS,
  GET_CUSTOMER_DASHBOARD_REQUEST,
  RESET_CUSTOMER_DASHBOARD_ISFETCHING,
  GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_FOR_DASHBOARD_SUCCESS
} from './constants';

function* get() {
  try {
    yield call(removeAPIError);
    yield put({ type: CUSTOMER_DASHBOARD_OBJECT_REQUESTING });
    let virtualCartResponse;

    const response = yield call(getCustomerDashboard);

    const clubShipment = response.data.data.find(
      (item) => item.type === 'clubShipment'
    );

    // if there is clubpackageId it means this is a traditional shipment
    if (clubShipment && clubShipment.object.processingStatus !== 'Completed') {
      if (clubShipment.object.clubPackageId) {
        virtualCartResponse = yield call(
          getClubShipmentVirtualCart,
          customerId(),
          clubShipment.object.id
        );
        yield put({
          type: GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_FOR_DASHBOARD_SUCCESS,
          payload: virtualCartResponse.data,
          clubMemberShipmentId: clubShipment.object.id
        });

        const clubPackageResponse = yield call(
          getClubPackage,
          clubShipment.object.clubPackageId
        );

        yield call(updateClubPackages, clubPackageResponse.data);
      } else {
        virtualCartResponse = yield call(
          getSubscriptionClubShipmentVirtualCart,
          customerId(),
          clubShipment.object.id
        );

        yield put({
          type: GET_CLUB_MEMBER_SHIPMENT_VIRTUAL_CART_FOR_DASHBOARD_SUCCESS,
          payload: virtualCartResponse.data,
          clubMemberShipmentId: clubShipment.object.id
        });
      }
    }

    yield put({
      type: GET_CUSTOMER_DASHBOARD_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CUSTOMER_DASHBOARD_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* updateClubPackages(clubPackage) {
  const clubPackages = [];

  if (clubPackage) {
    clubPackages.push(clubPackage);
  }

  yield put({
    type: LIST_CLUB_PACKAGES_SUCCESS,
    payload: { clubPackages }
  });
  return { clubPackages };
}

function* watchList() {
  yield takeLatest(GET_CUSTOMER_DASHBOARD_REQUEST, get);
}

export default function* customerDashboardSagas() {
  yield all([watchList()]);
}
